import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-visualizar-observacoes-plano',
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
  templateUrl: './visualizar-observacoes-plano.html',
  styleUrl: './visualizar-observacoes-plano.scss'
})
export class VisualizarObservacoesPlano {
  todasObservacoes: string[] = [];
  observacaoAtual!: string;
  total = 0;
  currentIndex = 0;
  public isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisualizarObservacoesPlano>,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;

    let observacoesRaw: string[] = [];

    if (Array.isArray(this.data.observacoes)) {
      observacoesRaw = this.data.observacoes;
    } else if (typeof this.data.observacoes === 'string') {
      observacoesRaw = this.data.observacoes.split(';');
    }

    this.todasObservacoes = observacoesRaw
      .map(o => (o ?? '').toString().trim())
      .filter(o => o.length > 0 && o.toLowerCase() !== 'null');

    this.total = this.todasObservacoes.length;

    if (this.total > 0) {
      this.observacaoAtual = this.todasObservacoes[0];
    }

    this.observacaoAtual = this.todasObservacoes[0];
    this.isLoading = false;
  }

  next(): void {
    if (this.currentIndex < this.total - 1) {
      this.currentIndex++;
      this.observacaoAtual = this.todasObservacoes[this.currentIndex];
    }
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.observacaoAtual = this.todasObservacoes[this.currentIndex];
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
